<template>
	<div class="w-full border-b border-b-light-400 dark:border-b-dark-500 p-2 min-h-[41px] flex items-center justify-between text-xs">
		<slot />
	</div>
</template>
